import actionConstants from '../constants/ActionConstants';

const initialState = {
  error: '',
  isfetching: false,
  success: '',
  isSuccess: false,
  supplierInfo: {},
};

export default function getSupplierDetails(state = initialState, action) {
  switch (action.type) {
    case actionConstants.GET_SUPPLIER_DETAILS_REQUEST:
      return {
        ...state,
        isfetching: true,
      };
    case actionConstants.GET_SUPPLIER_DETAILS_SUCCESS:
      return {
        ...state,
        supplierInfo: action.payload.supplierData,
        isfetching: false,
        isSuccess: true,
        success: action.message,
      };

    case actionConstants.GET_SUPPLIER_DETAILS_FAILURE:
      return {
        ...state,
        error: action.message,
        isfetching: false,
      };
    case actionConstants.GET_SUPPLIER_DETAILS_RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}
